import { styled } from 'linaria/react';

export const BreakableSafeText = styled.span`
  word-break: break-all;
`;
